import { ReadableUploadSource } from "../../base-types";

export interface IUploadSource {
    name: string;
    getReadableSourceAsync(): Promise<ReadableUploadSource>;
}
